// removed by extract-text-webpack-plugin
module.exports = {"action-panel":"action-panel"};


//////////////////
// WEBPACK FOOTER
// ./components/article-category/_ArticleCategoryBox.scss
// module id = ./components/article-category/_ArticleCategoryBox.scss
// module chunks = 0